"use client";

import { cn } from "@/utils/utils";
import { useHeaderActions } from "@/contexts/header-actions-context";
import { HeaderBreadcrumbs } from "./header-breadcrumbs";
import { useSidebar } from "./ui/sidebar";
import { SidebarToggleButton } from "./sidebar-toggle-button";

export const Header = () => {
  const { actions: headerActions } = useHeaderActions();
  const { open: isSidebarOpen, isMobile } = useSidebar();

  return (
    <header
      className={cn(
        "flex h-[var(--header-height)] w-full shrink-0 items-center justify-between gap-2 border-b px-3 py-2 sm:px-4",
      )}
    >
      <div className={cn("flex min-w-0 flex-1 items-center gap-2")}>
        {(isMobile || !isSidebarOpen) && <SidebarToggleButton />}
        <HeaderBreadcrumbs />
      </div>

      {headerActions && (
        <div className="flex h-full shrink-0 items-center gap-1 sm:gap-2">
          {headerActions}
        </div>
      )}
    </header>
  );
};
